import React, { useMemo } from 'react';

import { Helmet } from 'react-helmet';

import { FrontMatter, Platforms } from '../../../types';
import { getCanonical } from '../../utils';

interface Props {
  canonical: string;
  platform?: string;
  platforms?: Platforms;
  frontmatter?: FrontMatter;
  favicon?: string;
  siteName: string;
  siteImage: string;
  description: string;
}

export const SEO: React.FC<Props> = ({
  canonical,
  platform,
  platforms,
  favicon,
  siteName,
  siteImage,
  description,
  frontmatter,
  children,
}) => {
  if (!frontmatter) return null;

  const title = frontmatter.metaTitle || frontmatter.title || siteName;
  const image = frontmatter.image || siteImage;

  const metaDescription =
    frontmatter.description ||
    (platforms && platform && platforms[platform]?.description) ||
    description;

  const fixedCanonical = useMemo(() => getCanonical(canonical), [canonical]);

  return (
    <Helmet>
      <title>{title}</title>
      <meta property="og:title" content={title} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={image} />
      <meta property="og:type" content="website" />
      <meta name="description" content={metaDescription} />
      <link rel="icon" href={favicon} />
      {canonical && (
        <link rel="canonical" key={fixedCanonical} href={fixedCanonical} />
      )}
      {children}
    </Helmet>
  );
};
